class InputUpDownBase extends Component {
	constructor(el) {
		super(el);
		this.input = this.$find('input');
		this.min = +this.$el.dataset.min;
		this.max = +this.$el.dataset.max;
		this.incrementEl = this.$find('[data-increment]');
		this.decrementEl = this.$find('[data-decrement]');
		this.changeEvent = new Event('change', { 'bubbles': true });

		this.$el.__inputUpDownBase__ = this;

		this.addEventListeners();
	}

	incrementValue() {
		this.input.value++;
		this.checkBoundaries();
		this.input.dispatchEvent(this.changeEvent);
	}

	decrementValue() {
		this.input.value--;
		this.checkBoundaries();
		this.input.dispatchEvent(this.changeEvent);
	}

	checkBoundaries() {
		const value = parseInt(this.input.value, 10);

		if (this.max && value > this.max) {
			this.input.value = this.max;
		}

		if (this.min && value < this.min) {
			this.input.value = this.min;
		}
	}

	checkKey(e) {
		if (e.which > 59 || e.which < 48) {
			e.preventDefault();
		}
	}

	setMin(newMin) {
		this.min = parseInt(newMin, 10) || 1;
		this.$el.dataset.min = this.min;
		this.input.setAttribute('min', this.min);

		if (parseInt(this.input.value, 10) < this.min) {
			this.input.value = this.min;
		}

		this.checkBoundaries();
	}

	addEventListeners() {
		this.incrementEl.addEventListener('click', () => this.incrementValue());
		this.decrementEl.addEventListener('click', () => this.decrementValue());
		this.input.addEventListener('input', () => this.checkBoundaries());
		this.input.addEventListener('keypress', (e) => this.checkKey(e));
	}
}
